export const INTERNAL_CONVERSATION = 'internal'
export const COLLABORATOR_CONVERSATION = 'third_party'
export const CUSTOMER_CONVERSATION = 'enduser'
